import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@opengoal/ui';
import { useTranslation } from 'react-i18next';
import { queryClient } from '@/app/queryClient';
import { directionFor } from '@/i18n';

/**
 * Provider stack, outermost first.
 *
 * ThemeProvider also mounts the toast outlet, the tooltip provider and the
 * confirm dialog behind `useConfirm()`, so everything that shows one of those
 * must render inside it.
 */
export function Providers({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider direction={directionFor(i18n.language)}>{children}</ThemeProvider>
    </QueryClientProvider>
  );
}
